<template>
    <div class="mask" v-if="mode == 'voice'"></div>
    <div :class="isRecording ? 'ctrlProcessWave' : 'ctrlProcessWave op0'"></div>
    <!-- <textarea v-model="text" name="" id="" placeholder="识别结果将显示在这里"></textarea>
    <AUDIO ref="LogAudioPlayer" style="width:100%"></AUDIO>
     <div class="btn">
        <button @click="recOpen">打开录音,请求权限</button>
        <button @click="recClose">关闭录音,释放资源</button>
        <button @click="recStart">开始识别</button>
        <button @click="recStop" style="margin-right:80px">停止识别</button>
        <button @click="recPause">暂停</button>
        <button @click="recResume">继续</button>
        <button @click="recPlayLast">播放</button>
        <button @click="recUploadLast">上传</button>
        <button @click="recDownLast">本地下载</button>
    </div> -->
    <div :class="isRecording ? 'message' : 'message mt'" ref="chatContainer" v-if="mode == 'voice'">
        <div class="" v-for="item of qaList">
            <div :class="item.role === 'user' ? 'message-item' : 'message-item answer text-blue'"
                v-if="item.message.type === 'TOPIC'">
                <p>我猜您想问以下问题:</p>
                <div class="question" v-for="itx in item.message.list" @click="onTap(itx)">
                    {{ itx.question.question }}
                </div>
                <p>您可以点击选择上述问题，我会在您选择后回答哟</p>

            </div>
            <div :class="item.role === 'user' ? 'message-item' : 'message-item answer text-blue'"
                v-if="item.message.type !== 'TOPIC'">
                <span v-if="item.message.loading"><van-loading size="16px">加载中...</van-loading></span>
                {{ item.message.content }}
            </div>
        </div>

    </div>
    <div class="controls" v-if="mode == 'voice'">
        <div class="controls-btn"><img src="img/icon_chat.png" class="icon" /> 智能问答</div>
        <div class="controls-btn" @click="onTapShowModel"><img src="img/icon_model.png" class="icon" /> 显示模型</div>
    </div>
    <!-- 语音合成区域 -->
    <div class="tts-box" v-if="mode == 'voice'">
        <div class="tts-input-wrapper">
            <textarea 
                v-model="ttsText" 
                class="tts-input" 
                placeholder="请输入要合成的文字"
                rows="3"
            ></textarea>
            <button 
                class="tts-btn" 
                @click="synthesizeSpeech"
                :disabled="!ttsText.trim() || isSynthesizing"
            >
                {{ isSynthesizing ? '合成中...' : '播放语音' }}
            </button>
        </div>
        <audio ref="ttsAudioPlayer" style="display: none;"></audio>
    </div>
    <!-- <div>
        <p>连接状态: {{ status }}</p>
        <p>录音状态: {{ isRecording ? '录音中' : '未录音' }}</p>
    </div> -->
    <div class="voice-box" v-if="mode == 'voice'">
        <div class="btn" @touchstart.prevent="startRecording" @touchend.prevent.capture="stopRecording"
            @touchcancel.prevent.capture="cancelRecording">
            <img src="img/icon-mico.png" class="img" />
        </div>
        <div class="text">{{ tips }}</div>
    </div>
</template>

<script>
//加载必须要的core
import Recorder from 'recorder-core'
import 'recorder-core/src/engine/mp3'
import 'recorder-core/src/engine/mp3-engine'
import 'recorder-core/src/extensions/waveview'
import { eventBus } from "@/utils/eventBus"
import { getAuthInfo, chatByText } from '@/api/service'

export default {
    data() {
        return {
            userId: '',
            qaList: [],
            chatAuthData: null,
            tips: "按住说话",
            type: "mp3",
            bitRate: 16,
            sampleRate: 16000,
            duration: 0,
            durationTxt: "0",
            powerLevel: 0,
            logs: [],
            websocket: null,
            appkey: 'IvcUBvL969N6yoyt',
            token: 'c19cc567645f4f0c912a2281332b3397',
            status: '未连接',
            messages: [],
            isConnected: false,
            isRecording: false,
            text: "", // 存储识别结果
            taskId: null, // 任务ID,
            isLoaded: false,
            mode: '',
            isShow: 'hide',
            // 语音合成相关
            ttsText: '',
            ttsWebSocket: null,
            ttsTaskId: null,
            isSynthesizing: false,
            ttsAudioChunks: [],
        }
    },
    created() {
        this.Rec = Recorder;
    },
    mounted() {
        this.userId = this.generateUUID();
        // 注意：移动端浏览器要求权限请求必须在用户交互时触发，不能在页面加载时自动请求
        // 因此不在 mounted 中自动请求权限，而是在用户点击录音按钮时请求
        eventBus.on('voice', (value) => {
            // console.log(value)
            if (value !== 'hide') {
                this.isShow = value
                eventBus.emit('model_hide', true)
                this.mode = 'voice'
                // 每次进入语音模式时不自动请求权限，等用户点击录音按钮时再请求
            }
        })
    },
    beforeDestroy() {
        // 清理临时保存的 stream
        if (this._tempStream) {
            this._tempStream.getTracks().forEach(track => track.stop());
            this._tempStream = null;
        }
        // 清理录音资源
        this.recClose();
        // 清理语音合成资源
        this.disconnectTTSWebSocket();
    },
    methods: {
        onTapShowModel() {

            this.mode = ''
            this.qaList = [];
            this.$forceUpdate();
            eventBus.emit('model_hide', false)

        },
        onTap(itx) {
            let qa = {
                role: 'user',
                message: {
                    type: 'TEXT',
                    loading: false,
                    content: itx.question.question
                }
            }

            console.log(qa)
            this.qaList.push(qa)
            console.log(itx.answerList[0].textList[0].content)
            let obj = {
                role: 'system',
                message: {
                    type: 'TEXT',
                    loading: false,
                    content: itx.answerList[0].textList[0].content
                }
            }

            console.log(obj)
            this.qaList.push(obj)
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        },
        startRecording: async function () {
            // 开始录音前先请求麦克风权限
            try {
                // 检查是否是安全上下文（HTTPS 或 localhost）
                const isSecureContext = window.isSecureContext || location.protocol === 'https:' || location.hostname === 'localhost' || location.hostname === '127.0.0.1';
                if (!isSecureContext) {
                    alert('为了使用麦克风功能，请在 HTTPS 环境下访问，或使用 localhost');
                    return;
                }

                // 检查浏览器支持
                if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                    // 降级到旧版 API（部分移动浏览器）
                    const getUserMedia = navigator.mediaDevices?.getUserMedia || 
                                       navigator.getUserMedia || 
                                       navigator.webkitGetUserMedia || 
                                       navigator.mozGetUserMedia;
                    
                    if (!getUserMedia) {
                        alert('您的浏览器不支持录音功能，请使用现代浏览器（如 Chrome、Firefox、Safari）');
                        return;
                    }
                    
                    // 使用旧版 API
                    return new Promise((resolve, reject) => {
                        getUserMedia.call(navigator, { audio: true }, (stream) => {
                            // 保存 stream 以便后续使用
                            this._tempStream = stream;
                            this.text = '';
                            this.recOpen();
                            console.log('startRecording');
                            this.tips = '加载模型中';
                            this.mode = 'voice';
                            eventBus.emit('model_hide', true);
                            resolve();
                        }, (err) => {
                            this.handleMicrophoneError(err);
                            reject(err);
                        });
                    });
                }
                
                // 直接请求麦克风权限（新版 API）
                const stream = await navigator.mediaDevices.getUserMedia({ 
                    audio: {
                        echoCancellation: true,
                        noiseSuppression: true,
                        autoGainControl: true
                    } 
                });
                
                // 保存 stream，不要在获取权限后立即关闭（某些移动浏览器可能有问题）
                this._tempStream = stream;
                
                // 权限获取成功，开始录音
                this.text = '';
                this.recOpen();
                console.log('startRecording');
                this.tips = '加载模型中';
                this.mode = 'voice';
                eventBus.emit('model_hide', true);
            } catch (err) {
                console.error('获取麦克风权限失败:', err);
                this.handleMicrophoneError(err);
            }
        },
        
        // 处理麦克风错误
        handleMicrophoneError(err) {
            let errorMessage = '获取麦克风权限失败';
            
            if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
                // 检测是否是微信浏览器
                const isWeChat = /MicroMessenger/i.test(navigator.userAgent);
                if (isWeChat) {
                    errorMessage = '请在微信右上角菜单中，选择"刷新"后重新授权麦克风权限，或点击右上角"..."选择"在浏览器中打开"';
                } else {
                    errorMessage = '请允许访问麦克风权限\n\n操作步骤：\n1. 点击浏览器地址栏左侧的锁图标或信息图标\n2. 允许访问麦克风\n3. 刷新页面重试';
                }
            } else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
                errorMessage = '未检测到麦克风设备，请检查您的麦克风连接并确保已连接麦克风';
            } else if (err.name === 'NotReadableError' || err.name === 'TrackStartError') {
                errorMessage = '麦克风被其他应用占用，请关闭其他使用麦克风的应用后重试';
            } else if (err.name === 'OverconstrainedError') {
                errorMessage = '麦克风不支持所需的音频参数';
            } else if (err.name === 'SecurityError') {
                errorMessage = '安全错误：请确保在 HTTPS 环境下访问，或检查浏览器安全设置';
            } else {
                errorMessage = `获取麦克风权限失败：${err.message || err.name || '未知错误'}`;
            }
            
            alert(errorMessage);
            console.error('麦克风错误详情:', err);
        },
        stopRecording: function () {
            console.log('stopRecording');
            let that = this;
            this.tips = '按住说话';
            setTimeout(function () {
                that.recStop();
            }, 1500);
        },
        cancelRecording: function () {
            console.log('cancelRecording');
        },
        reclog: function (msg, color, res) {
            var obj = {
                idx: this.logs.length
                , msg: msg
                , color: color
                , res: res
                , playMsg: ""
                , down: 0
                , down64Val: ""
            };
            if (res && res.blob) {
                console.logLast = obj;
            };
            this.logs.splice(0, 0, obj);
        },

        recOpen: function () {
            var that = this;
            var rec = this.rec = Recorder({
                type: that.type,
                bitRate: +that.bitRate,
                sampleRate: +that.sampleRate,
                onProcess: function (buffers, powerLevel, duration, sampleRate) {
                    that.duration = duration;
                    that.durationTxt = that.formatMs(duration, 1);
                    that.powerLevel = powerLevel;

                    // 实时发送音频数据到阿里云
                    if (that.isRecording && that.websocket && that.websocket.readyState === WebSocket.OPEN) {
                        // 获取最新的音频数据
                        // const buffer = buffers[buffers.length - 1];
                        // // 转换为16位PCM
                        // const pcmData = that.floatTo16BitPCM(buffer);
                        // // 发送二进制数据

                        if (buffers.length > 0) {
                            if (buffers.length % 1 !== 0) return
                            const pcm = new Recorder.SampleData([...buffers.slice(buffers.length - 1)], sampleRate, 16000)
                            const blob = new Blob([pcm.data], { type: 'audio/pcm' })
                            // ws && ws.send(blob)
                            that.websocket.send(blob);
                        }
                    }

                    that.wave.input(buffers[buffers.length - 1], powerLevel, sampleRate);
                }
            });

            rec.open(function () {
                that.reclog("已打开:" + that.type + " " + that.sampleRate + "hz " + that.bitRate + "kbps", 2);
                if (!that.isLoaded) {
                    that.wave = Recorder.WaveView({ elem: ".ctrlProcessWave" });
                    that.isLoaded = true;
                }

                // 清理临时保存的 stream（权限已通过 Recorder 获取）
                if (that._tempStream) {
                    that._tempStream.getTracks().forEach(track => track.stop());
                    that._tempStream = null;
                }

                // 打开录音成功后连接WebSocket
                that.connectWebSocket();

            }, function (msg, isUserNotAllow) {
                that.reclog((isUserNotAllow ? "UserNotAllow，" : "") + "打开失败：" + msg, 1);
                // 清理临时 stream
                if (that._tempStream) {
                    that._tempStream.getTracks().forEach(track => track.stop());
                    that._tempStream = null;
                }
                
                // 如果是用户拒绝权限，给出友好提示
                if (isUserNotAllow) {
                    const isWeChat = /MicroMessenger/i.test(navigator.userAgent);
                    if (isWeChat) {
                        alert('需要麦克风权限\n\n请在微信右上角菜单中，选择"刷新"后重新授权麦克风权限，或点击右上角"..."选择"在浏览器中打开"');
                    } else {
                        alert('需要麦克风权限才能使用语音功能\n\n操作步骤：\n1. 点击浏览器地址栏左侧的锁图标或信息图标\n2. 允许访问麦克风\n3. 再次点击录音按钮');
                    }
                } else {
                    alert('打开录音失败：' + msg);
                }
                that.tips = '按住说话';
            });
        },

        recClose: function () {
            var rec = this.rec;
            this.rec = null;
            if (rec) {
                rec.close();
                console.log("已关闭");
            } else {
                console.log("未打开录音", 1);
            };
            // 关闭WebSocket连接
            this.disconnectWebSocket();
        },

        recStart: function () {
            if (!this.rec || !Recorder.IsOpen()) {
                console.log("未打开录音", 1);
                return;
            }

            if (!this.isConnected) {
                console.log("WebSocket未连接", 1);
                return;
            }
            console.log(this.text);
            let obj = {
                role: 'user',
                message: {
                    type: 'TEXT',
                    loading: true,
                    content: this.text
                }
            }
            this.qaList.push(obj);
            this.$forceUpdate();
            this.$nextTick(() => {
                this.scrollToBottom();
            });
            console.log(JSON.stringify(this.qaList));
            this.rec.start();
            this.isRecording = true;
            this.tips = '请说话';
            var set = this.rec.set;
            console.log("录制中：" + set.type + " " + set.sampleRate + "hz " + set.bitRate + "kbps");
        },

        recPause: function () {
            if (this.rec && Recorder.IsOpen()) {
                this.rec.pause();
                this.isRecording = false;
            } else {
                console.log("未打开录音", 1);
            };
        },

        recResume: function () {
            if (this.rec && Recorder.IsOpen()) {
                this.rec.resume();
                this.isRecording = true;
            } else {
                console.log("未打开录音", 1);
            };
        },

        recStop: function () {
            if (!(this.rec && Recorder.IsOpen())) {
                console.log("未打开录音", 1);
                return;
            }

            var that = this;
            var rec = that.rec;

            debugger;
            // 停止录音
            rec.stop(function (blob, duration) {
                that.reclog("已录制:", "", {
                    blob: blob,
                    duration: duration,
                    durationTxt: that.formatMs(duration),
                    rec: rec
                });

                //发送结束标记
                if (that.websocket && that.websocket.readyState === WebSocket.OPEN) {
                    const stopMessage = {
                        header: {
                            message_id: that.generateUUID(),
                            task_id: that.taskId,
                            name: "StopTranscription",
                            namespace: "SpeechTranscriber",
                            appkey: that.appkey
                        },
                        payload: {}
                    };
                    that.websocket.send(JSON.stringify(stopMessage));
                }
                that.recClose();
                that.isRecording = false;
                that.startChat();
            }, function (s) {
                that.reclog("录音失败：" + s, 1);
                that.isRecording = false;
            });
        },

        startChat() {
            if (this.text === '') {
                this.qaList.length = this.qaList.length - 1;
                alert('语音没有解析成功请重试');
                return;
            }
            this.qaList[this.qaList.length - 1].message.loading = false;
            this.qaList[this.qaList.length - 1].message.content = this.text;
            let params = {
                apiKey: "14f1e32a41aae9a2f25adfd013b2f618",
                thirdPartUserId: this.userId
            }
            getAuthInfo(params).then(res => {
                if (res && res.data) {
                    this.chatAuthData = res.data;
                    console.log(JSON.stringify(this.chatAuthData))
                    localStorage.setItem('CHAT_AUTH_INFO', JSON.stringify(this.chatAuthData))
                    this.sendChat();
                }
            })
        },
        sendChat() {
            console.log(this.text)
            let params = {
                chanel: 1,
                questioning: this.text
            }
            chatByText(params).then(res => {
                if (res && res.data && res.data.qaResult) {
                    let obj;
                    // if (res.data.qaResult.qaType === 'STANDARD' || res.data.qaResult.qaType === 'SYSTEM' || res.data.qaResult.qaType === 'CHAT') {
                    //     obj = {
                    //         role: 'system',
                    //         message: {
                    //             type: 'TEXT',
                    //             loading: false,
                    //             content: res.data.qaResult.answer[0].content
                    //         }
                    //     }
                    // }
                    if (res.data.qaResult.qaType === 'TOPIC') {
                        obj = {
                            role: 'system',
                            message: {
                                type: 'TOPIC',
                                loading: false,
                                content: res.data.qaResult.answer[0].content,
                                list: res.data.qaResult.topicQaInfos
                            }
                        }
                    } else {
                        obj = {
                            role: 'system',
                            message: {
                                type: 'TEXT',
                                loading: false,
                                content: res.data.qaResult.answer[0].content
                            }
                        }
                    }
                    console.log(obj)
                    this.qaList.push(obj)
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });
                    console.log(JSON.stringify(this.qaList));
                }
            })
        },
        // 将浮点音频数据转换为16位PCM
        floatTo16BitPCM(input) {
            const output = new Int16Array(input.length);
            for (let i = 0; i < input.length; i++) {
                const s = Math.max(-1, Math.min(1, input[i]));
                output[i] = s < 0 ? s * 0x8000 : s * 0x7FFF;
            }
            return output.buffer;
        },

        // 更新连接状态
        updateStatus(status) {
            this.status = status;
            this.isConnected = status === '已连接';
        },

        // 生成 UUID
        generateUUID() {
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            ).replace(/-/g, '');
        },

        // 打开WebSocket连接
        connectWebSocket() {
            const socketUrl = `wss://nls-gateway.cn-shanghai.aliyuncs.com/ws/v1?token=${this.token}`;

            this.websocket = new WebSocket(socketUrl);
            this.websocket.onopen = () => {
                console.log('已连接')
                this.updateStatus('已连接');
                this.logMessage('连接到阿里云语音识别服务');

                // 生成任务ID
                this.taskId = this.generateUUID();

                const startTranscriptionMessage = {
                    header: {
                        appkey: this.appkey,
                        namespace: "SpeechTranscriber",
                        name: "StartTranscription",
                        task_id: this.taskId,
                        message_id: this.generateUUID()
                    },
                    payload: {
                        "format": "pcm",
                        "sample_rate": 16000,
                        "enable_intermediate_result": true,
                        "enable_punctuation_prediction": true,
                        "enable_inverse_text_normalization": true
                    }
                };

                this.websocket.send(JSON.stringify(startTranscriptionMessage));
                this.recStart();
            };

            this.websocket.onmessage = (event) => {
                try {
                    const message = JSON.parse(event.data);
                    //console.log(JSON.stringify(message));
                    this.handleWebSocketMessage(message);
                } catch (error) {

                }

            };

            this.websocket.onerror = (event) => {
                this.updateStatus('错误');
                this.logMessage('WebSocket 错误: ' + event);
                console.error('WebSocket error:', event);
            };

            this.websocket.onclose = () => {
                this.updateStatus('断开连接');
                this.logMessage('与语音识别服务断开连接');
                this.isConnected = false;
                this.isRecording = false;
            };

        },

        // 处理WebSocket消息
        handleWebSocketMessage(message) {
            const header = message.header;
            const payload = message.payload;

            switch (header.name) {
                case "TranscriptionStarted":
                    this.logMessage("语音识别开始");
                    break;

                case "TranscriptionResultChanged":
                    // 更新中间结果
                    // if (payload.result) {
                    //     this.text =  payload.result;
                    //     //this.logMessage("中间结果: " + payload.result);
                    // }
                    break;

                case "TranscriptionCompleted":
                    // 最终结果
                    // if (payload.result) {
                    //     this.text = payload.result;
                    //     this.logMessage("最终结果: " + payload.result);
                    // }
                    this.logMessage("语音识别完成");
                    break;

                case "SentenceBegin":
                    this.logMessage("句子开始");
                    break;

                case "SentenceEnd":
                    this.logMessage("句子结束");

                    if (payload.result) {
                        this.text = this.text + payload.result;
                        this.logMessage("最终结果: " + payload.result);
                    }
                    break;

                case "TaskFailed":
                    this.logMessage("任务失败: " + (payload.message || "未知错误"));
                    break;

                default:
                    this.logMessage("收到消息: " + header.name);
                    break;
            }
        },

        // 断开WebSocket连接
        disconnectWebSocket() {
            if (this.websocket) {
                this.websocket.close();
            }
            this.updateStatus('未连接');
            this.isConnected = false;
            this.isRecording = false;

            //this.recClose();
        },

        // 日志消息
        logMessage(message) {
            this.messages.push(message);
            // 自动滚动到底部
            this.$nextTick(() => {
                const messagesDiv = this.$refs.messages;
                if (messagesDiv) {
                    messagesDiv.scrollTop = messagesDiv.scrollHeight;
                }
            });
        },

        // 以下是你原有的其他方法，保持不变
        recPlayLast: function () {
            if (!console.logLast) {
                console.log("请先录音，然后停止后再播放", 1);
                return;
            };
            this.recplay(console.logLast.idx);
        },
        recUploadLast: function () {
            if (!console.logLast) {
                console.log("请先录音，然后停止后再上传", 1);
                return;
            };
            var that = this;
            var blob = console.logLast.res.blob;
        },
        recDownLast: function () {
            if (!console.logLast) {
                console.log("请先录音，然后停止后再下载", 1);
                return;
            };
            this.recdown(console.logLast.idx);
        },
        recplay: function (idx) {
            var This = this;
            var o = this.logs[this.logs.length - idx - 1];
            o.play = (o.play || 0) + 1;
            var logmsg = function (msg) {
                o.playMsg = '<span style="color:green">' + o.play + '</span> ' + This.getTime() + " " + msg;
            };
            logmsg("");

            var audio = this.$refs.LogAudioPlayer;
            audio.controls = true;
            if (!(audio.ended || audio.paused)) {
                audio.pause();
            };
            audio.onerror = function (e) {
                logmsg('<span style="color:red">播放失败[' + audio.error.code + ']' + audio.error.message + '</span>');
            };
            audio.src = (window.URL || webkitURL).createObjectURL(o.res.blob);
            audio.play();
        },
        recdown: function (idx) {
            var This = this;
            var o = this.logs[this.logs.length - idx - 1];
            o.down = (o.down || 0) + 1;

            o = o.res;
            var name = "rec-" + o.duration + "ms-" + (o.rec.set.bitRate || "-") + "kbps-" + (o.rec.set.sampleRate || "-") + "hz." + (o.rec.set.type || (/\w+$/.exec(o.blob.type) || [])[0] || "unknown");
            var downA = document.createElement("A");
            downA.href = (window.URL || webkitURL).createObjectURL(o.blob);
            downA.download = name;
            downA.click();
        },
        recdown64: function (idx) {
            var This = this;
            var o = this.logs[this.logs.length - idx - 1];
            var reader = new FileReader();
            reader.onloadend = function () {
                o.down64Val = reader.result;
            };
            reader.readAsDataURL(o.res.blob);
        },
        getTime: function () {
            var now = new Date();
            var t = ("0" + now.getHours()).substr(-2)
                + ":" + ("0" + now.getMinutes()).substr(-2)
                + ":" + ("0" + now.getSeconds()).substr(-2);
            return t;
        },
        formatMs: function (ms, all) {
            var ss = ms % 1000; ms = (ms - ss) / 1000;
            var s = ms % 60; ms = (ms - s) / 60;
            var m = ms % 60; ms = (ms - m) / 60;
            var h = ms;
            var t = (h ? h + ":" : "")
                + (all || h + m ? ("0" + m).substr(-2) + ":" : "")
                + (all || h + m + s ? ("0" + s).substr(-2) + "″" : "")
                + ("00" + ss).substr(-3);
            return t;
        },
        intp: function (s, len) {
            s = s == null ? "-" : s + "";
            if (s.length >= len) return s;
            return ("_______" + s).substr(-len);
        },
        scrollToBottom() {
            this.$refs.chatContainer.scrollTop =
                this.$refs.chatContainer.scrollHeight;
        },
        
        // 检查麦克风权限
        async checkMicrophonePermission() {
            try {
                // 检查是否支持 permissions API
                if (navigator.permissions && navigator.permissions.query) {
                    const result = await navigator.permissions.query({ name: 'microphone' });
                    return result.state === 'granted';
                } else {
                    // 如果不支持 permissions API，直接尝试请求权限来检查
                    try {
                        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                        stream.getTracks().forEach(track => track.stop()); // 停止流以释放资源
                        return true;
                    } catch (err) {
                        return false;
                    }
                }
            } catch (err) {
                console.error('检查麦克风权限出错:', err);
                // 降级方案：尝试直接请求权限
                try {
                    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                    stream.getTracks().forEach(track => track.stop());
                    return true;
                } catch (e) {
                    return false;
                }
            }
        },
        
        // 请求麦克风权限
        async requestMicrophonePermission() {
            try {
                // 检查是否是安全上下文（HTTPS 或 localhost）
                const isSecureContext = window.isSecureContext || location.protocol === 'https:' || location.hostname === 'localhost' || location.hostname === '127.0.0.1';
                if (!isSecureContext) {
                    alert('为了使用麦克风功能，请在 HTTPS 环境下访问，或使用 localhost');
                    return;
                }

                // 检查浏览器支持（包括旧版 API）
                const getUserMedia = navigator.mediaDevices?.getUserMedia || 
                                   navigator.getUserMedia || 
                                   navigator.webkitGetUserMedia || 
                                   navigator.mozGetUserMedia;
                
                if (!getUserMedia) {
                    alert('您的浏览器不支持录音功能，请使用现代浏览器（如 Chrome、Firefox、Safari）');
                    return;
                }

                // 使用新版 API
                if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                    const stream = await navigator.mediaDevices.getUserMedia({ 
                        audio: {
                            echoCancellation: true,
                            noiseSuppression: true,
                            autoGainControl: true
                        } 
                    });
                    // 请求成功后立即停止流，因为我们只是测试权限
                    stream.getTracks().forEach(track => track.stop());
                    console.log('麦克风权限已授权');
                } else {
                    // 使用旧版 API（Promise 包装）
                    return new Promise((resolve, reject) => {
                        getUserMedia.call(navigator, { audio: true }, (stream) => {
                            stream.getTracks().forEach(track => track.stop());
                            console.log('麦克风权限已授权');
                            resolve();
                        }, (err) => {
                            this.handleMicrophoneError(err);
                            reject(err);
                        });
                    });
                }
            } catch (err) {
                console.error('请求麦克风权限失败:', err);
                this.handleMicrophoneError(err);
            }
        },
        
        // 语音合成相关方法
        synthesizeSpeech() {
            if (!this.ttsText.trim()) {
                alert('请输入要合成的文字');
                return;
            }
            
            if (this.isSynthesizing) {
                return;
            }
            
            this.isSynthesizing = true;
            this.ttsAudioChunks = [];
            
            // 连接阿里云语音合成WebSocket
            this.connectTTSWebSocket();
        },
        
        // 连接语音合成WebSocket
        connectTTSWebSocket() {
            const socketUrl = `wss://nls-gateway.cn-shanghai.aliyuncs.com/ws/v1?token=${this.token}`;
            
            this.ttsWebSocket = new WebSocket(socketUrl);
            // 设置二进制类型为blob，以便接收音频数据
            this.ttsWebSocket.binaryType = 'blob';
            
            this.ttsWebSocket.onopen = () => {
                console.log('TTS WebSocket已连接');
                
                // 生成任务ID
                this.ttsTaskId = this.generateUUID();
                
                // 发送开始合成消息
                const startSynthesisMessage = {
                    header: {
                        appkey: this.appkey,
                        namespace: "SpeechSynthesizer",
                        name: "StartSynthesis",
                        task_id: this.ttsTaskId,
                        message_id: this.generateUUID()
                    },
                    payload: {
                        format: "mp3",
                        sample_rate: 16000,
                        text: this.ttsText,
                        voice: "aiqi", // 可选：aiqi, aijia, aicheng, aijing, aiyun, aiyue, aiyunxiang
                        volume: 50,
                        speech_rate: 0,
                        pitch_rate: 0
                    }
                };
                
                this.ttsWebSocket.send(JSON.stringify(startSynthesisMessage));
            };
            
            this.ttsWebSocket.onmessage = (event) => {
                try {
                    // 检查是否是二进制数据（音频数据）
                    if (event.data instanceof Blob) {
                        // 接收音频数据
                        this.handleTTSAudioData(event.data);
                    } else if (event.data instanceof ArrayBuffer) {
                        // 将ArrayBuffer转换为Blob
                        const blob = new Blob([event.data], { type: 'audio/mp3' });
                        this.handleTTSAudioData(blob);
                    } else {
                        // 处理文本消息
                        const message = JSON.parse(event.data);
                        this.handleTTSMessage(message);
                    }
                } catch (error) {
                    console.error('处理TTS消息错误:', error);
                    // 如果解析失败，可能是二进制数据，尝试作为音频处理
                    if (event.data) {
                        try {
                            const blob = new Blob([event.data], { type: 'audio/mp3' });
                            this.handleTTSAudioData(blob);
                        } catch (e) {
                            console.error('处理音频数据失败:', e);
                        }
                    }
                }
            };
            
            this.ttsWebSocket.onerror = (event) => {
                console.error('TTS WebSocket错误:', event);
                alert('语音合成连接失败，请重试');
                this.isSynthesizing = false;
            };
            
            this.ttsWebSocket.onclose = () => {
                console.log('TTS WebSocket已断开');
                this.isSynthesizing = false;
            };
        },
        
        // 处理TTS文本消息
        handleTTSMessage(message) {
            const header = message.header;
            const payload = message.payload;
            
            switch (header.name) {
                case "SynthesisStarted":
                    console.log("语音合成开始");
                    break;
                    
                case "SynthesisCompleted":
                    console.log("语音合成完成");
                    // 合成完成，播放音频
                    // 延迟一小段时间确保所有音频数据都已接收
                    setTimeout(() => {
                        this.playTTSAudio();
                    }, 100);
                    break;
                    
                case "TaskFailed":
                    console.error("TTS任务失败:", payload.message || "未知错误");
                    alert('语音合成失败：' + (payload.message || "未知错误"));
                    this.isSynthesizing = false;
                    this.disconnectTTSWebSocket();
                    break;
                    
                default:
                    console.log("收到TTS消息:", header.name);
                    break;
            }
        },
        
        // 处理TTS音频数据
        handleTTSAudioData(data) {
            // 将接收到的音频数据添加到数组中
            if (data instanceof Blob && data.size > 0) {
                this.ttsAudioChunks.push(data);
                console.log('接收到音频数据块，大小:', data.size, '字节');
            }
        },
        
        // 播放TTS音频
        playTTSAudio() {
            if (this.ttsAudioChunks.length === 0) {
                console.warn('没有音频数据可播放');
                this.isSynthesizing = false;
                return;
            }
            
            // 将所有音频块合并
            const audioBlob = new Blob(this.ttsAudioChunks, { type: 'audio/mp3' });
            const audioUrl = URL.createObjectURL(audioBlob);
            
            const audioPlayer = this.$refs.ttsAudioPlayer;
            if (audioPlayer) {
                audioPlayer.src = audioUrl;
                audioPlayer.onended = () => {
                    // 播放结束后清理
                    URL.revokeObjectURL(audioUrl);
                    this.isSynthesizing = false;
                    this.disconnectTTSWebSocket();
                };
                audioPlayer.onerror = (error) => {
                    console.error('播放音频错误:', error);
                    alert('播放音频失败');
                    URL.revokeObjectURL(audioUrl);
                    this.isSynthesizing = false;
                    this.disconnectTTSWebSocket();
                };
                
                audioPlayer.play().catch(error => {
                    console.error('播放失败:', error);
                    alert('播放音频失败：' + error.message);
                    URL.revokeObjectURL(audioUrl);
                    this.isSynthesizing = false;
                    this.disconnectTTSWebSocket();
                });
            }
        },
        
        // 断开TTS WebSocket连接
        disconnectTTSWebSocket() {
            if (this.ttsWebSocket) {
                // 发送停止消息
                if (this.ttsWebSocket.readyState === WebSocket.OPEN && this.ttsTaskId) {
                    const stopMessage = {
                        header: {
                            message_id: this.generateUUID(),
                            task_id: this.ttsTaskId,
                            name: "StopSynthesis",
                            namespace: "SpeechSynthesizer",
                            appkey: this.appkey
                        },
                        payload: {}
                    };
                    try {
                        this.ttsWebSocket.send(JSON.stringify(stopMessage));
                    } catch (error) {
                        console.error('发送停止消息失败:', error);
                    }
                }
                
                this.ttsWebSocket.close();
                this.ttsWebSocket = null;
                this.ttsTaskId = null;
            }
        },
    }
}
</script>


<style lang="scss" scoped>
.voice-box {
    display: flex;
    justify-content: center;
    width: 80px;
    height: 80px;
    flex-wrap: wrap;
    position: fixed;
    bottom: 50px;
    left: calc(50vw - 45px);
    z-index: 999;
    color: #fff;

    .btn {
        background-color: #fff;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 4px;
        pointer-events: auto;

        .img {
            width: 24px;
        }
    }
}

.ctrlProcessWave {
    width: 100vw;
    height: 100px;
    position: fixed;
    top: 16vh;
    left: 0px;
    z-index: 9999;
}

.message {
    padding: 35px;
    height: 220px;
    width: calc(100vw - 70px);
    overflow: hidden;
    overflow-y: scroll;
    // background-color: #ffcc00;
    position: fixed;
    z-index: 999;
    top: 30vh;

    &-item {
        text-align: right;
        margin: 10px 0px;
        font-size: 16px;
        line-height: 1.2;
        color: #fff;
        margin-bottom: 20px;

        .question {
            text-decoration: underline;
            display: list-item;
            list-style-type: disc;
            /* 实心圆点 */
            list-style-position: inside;
            /* 圆点在内侧 */
            margin-left: 0px;
            line-height: 1.8;
            /* 缩进 */
        }
    }

    .answer {
        text-align: left;
    }

    .text-blue {
        color: #50BCFF;
    }
}

.mt {
    top: 16vh;
    height: calc(16vh + 220px);
}

.op0 {
    opacity: 0;
    pointer-events: none;
}

.mask {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba($color: #000000, $alpha: 0.8);
    z-index: 99;
}

.controls {
    padding: 10px;
    display: flex;
    justify-content: center;
    position: fixed;
    width: calc(100vw - 20px);
    z-index: 999999;
    bottom: 144px;

    .controls-btn {
        width: 120px;
        height: 32px;
        border-radius: 16px;
        color: #333;
        line-height: 32px;
        display: flex;
        justify-content: center;
        background-color: #eee;
        align-items: center;
        margin: 0px 10px;

        .icon {
            margin: 0px 8px;
            height: 16px;
        }
    }
}

.tts-box {
    position: fixed;
    bottom: 200px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100vw - 40px);
    max-width: 500px;
    z-index: 999;
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 12px;
    padding: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    .tts-input-wrapper {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .tts-input {
        width: 100%;
        padding: 12px;
        border: 1px solid #ddd;
        border-radius: 8px;
        font-size: 14px;
        font-family: inherit;
        resize: vertical;
        box-sizing: border-box;
        outline: none;
        transition: border-color 0.3s;

        &:focus {
            border-color: #50BCFF;
        }

        &::placeholder {
            color: #999;
        }
    }

    .tts-btn {
        padding: 12px 24px;
        background-color: #50BCFF;
        color: #fff;
        border: none;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.3s, opacity 0.3s;
        outline: none;

        &:hover:not(:disabled) {
            background-color: #3aa8e6;
        }

        &:active:not(:disabled) {
            background-color: #2d8bc7;
        }

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
    }
}
</style>